/* tslint:disable */
/* eslint-disable */
/**
 * Lumen Failure Management API
 * <h5>ToDo: API description</h5>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    FailureStatusFilter,
    FailureStatusFilterFromJSON,
    FailureStatusFilterFromJSONTyped,
    FailureStatusFilterToJSON,
    FilterLogicalOperator,
    FilterLogicalOperatorFromJSON,
    FilterLogicalOperatorFromJSONTyped,
    FilterLogicalOperatorToJSON,
    SortingDto,
    SortingDtoFromJSON,
    SortingDtoFromJSONTyped,
    SortingDtoToJSON,
} from './';

/**
 * 
 * @export
 * @interface GetAllFailuresQuery
 */
export interface GetAllFailuresQuery {
    /**
     * 
     * @type {FailureStatusFilter}
     * @memberof GetAllFailuresQuery
     */
    statusFilter?: FailureStatusFilter;
    /**
     * 
     * @type {boolean}
     * @memberof GetAllFailuresQuery
     */
    onlyNotAssignedToRepairman?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetAllFailuresQuery
     */
    exapanseIds?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetAllFailuresQuery
     */
    natureIds?: Array<string> | null;
    /**
     * 
     * @type {number}
     * @memberof GetAllFailuresQuery
     */
    page?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GetAllFailuresQuery
     */
    pageSize?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GetAllFailuresQuery
     */
    skip?: number;
    /**
     * 
     * @type {number}
     * @memberof GetAllFailuresQuery
     */
    take?: number;
    /**
     * 
     * @type {FilterLogicalOperator}
     * @memberof GetAllFailuresQuery
     */
    filterLogicalOperator?: FilterLogicalOperator;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof GetAllFailuresQuery
     */
    filterKeys?: { [key: string]: any; } | null;
    /**
     * 
     * @type {Array<SortingDto>}
     * @memberof GetAllFailuresQuery
     */
    sortings?: Array<SortingDto> | null;
}

export function GetAllFailuresQueryFromJSON(json: any): GetAllFailuresQuery {
    return GetAllFailuresQueryFromJSONTyped(json, false);
}

export function GetAllFailuresQueryFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAllFailuresQuery {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'statusFilter': !exists(json, 'statusFilter') ? undefined : FailureStatusFilterFromJSON(json['statusFilter']),
        'onlyNotAssignedToRepairman': !exists(json, 'onlyNotAssignedToRepairman') ? undefined : json['onlyNotAssignedToRepairman'],
        'exapanseIds': !exists(json, 'exapanseIds') ? undefined : json['exapanseIds'],
        'natureIds': !exists(json, 'natureIds') ? undefined : json['natureIds'],
        'page': !exists(json, 'page') ? undefined : json['page'],
        'pageSize': !exists(json, 'pageSize') ? undefined : json['pageSize'],
        'skip': !exists(json, 'skip') ? undefined : json['skip'],
        'take': !exists(json, 'take') ? undefined : json['take'],
        'filterLogicalOperator': !exists(json, 'filterLogicalOperator') ? undefined : FilterLogicalOperatorFromJSON(json['filterLogicalOperator']),
        'filterKeys': !exists(json, 'filterKeys') ? undefined : json['filterKeys'],
        'sortings': !exists(json, 'sortings') ? undefined : (json['sortings'] === null ? null : (json['sortings'] as Array<any>).map(SortingDtoFromJSON)),
    };
}

export function GetAllFailuresQueryToJSON(value?: GetAllFailuresQuery | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'statusFilter': FailureStatusFilterToJSON(value.statusFilter),
        'onlyNotAssignedToRepairman': value.onlyNotAssignedToRepairman,
        'exapanseIds': value.exapanseIds,
        'natureIds': value.natureIds,
        'page': value.page,
        'pageSize': value.pageSize,
        'skip': value.skip,
        'take': value.take,
        'filterLogicalOperator': FilterLogicalOperatorToJSON(value.filterLogicalOperator),
        'filterKeys': value.filterKeys,
        'sortings': value.sortings === undefined ? undefined : (value.sortings === null ? null : (value.sortings as Array<any>).map(SortingDtoToJSON)),
    };
}


